import React from 'react';
import { FormControl } from '@/components/ui/form';
import { Input } from '@/components/ui/input';

const FormControlNumber = ({ field, property, name }) => {
  return (
    <FormControl>
      <Input
        {...field}
        type="number"
        placeholder={`Enter ${name}`}
        onChange={(e) => {
          const value = e.target.value === '' ? '' : Number(e.target.value);
          field.onChange(value);
        }}
      />
    </FormControl>
  );
};

export default FormControlNumber;